<script lang="ts">
  export let name;
  export let value;
</script>

<select class="config-input" id="cfg_{name}" {value}>
  <option value="lan8270">LAN8270</option>
  <option value="rtl8201">RTL8201</option>
  <option value="ip101">IP101</option>
</select>